import Cookies from 'js-cookie';

const canRunAds = () => {
  return Cookies.get('gatsby-gdpr') === 'true';
};
export const allowAds = canRunAds();
